import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Avatar, Typography, Menu, Dropdown } from "antd";
import classnames from "classnames";
import { AppPathNames } from "@/constants/AppPathNames";
import { useGates } from "@/gates";
import * as permissions from "@/gates/permissions";

import "./User.scss";

const { Text } = Typography;
const { Item } = Menu;

/**
 * User drop down menu contain: setting (disabled),
 * Invitations (disabled) and sign out
 * @param {(void)=>void} onSignOut signout function
 */
const UserDropDownMenu = ({ onSignOut }) => {
  const { canAll, can, cannot } = useGates();
  return (
    <Menu className="user__dropdown">
      <Item className="user__dropdown-item" disabled={!canAll([permissions.USERS_READ, permissions.INVITATIONS_READ])}>
        <Link to={AppPathNames.settings} disabled={!canAll([permissions.USERS_READ, permissions.INVITATIONS_READ])}>
          Settings
        </Link>
      </Item>
      {can(permissions.AVERROES_USER) && (
        <Item className="user__dropdown-item" disabled={cannot(permissions.AVERROES_ADMIN)}>
          <Link to={AppPathNames.adminDashboard} disabled={cannot(permissions.AVERROES_ADMIN)}>
            Admin Dashboard
          </Link>
        </Item>
      )}
      <Item className="user__dropdown-item">
        <button className="signout-btn" onClick={onSignOut}>
          Sign Out
        </button>
      </Item>
    </Menu>
  );
};

/**
 * Main component used in Header component
 * @param {string} className className
 * @param {string} userName userName
 * @param {(void)=>void} onSignOut signout function
 */
const User = ({ className, userName, onSignOut, organization }) => {
  const [active, setActive] = useState(false);

  return (
    <Dropdown
      className={classnames("user", {
        [className]: className,
      })}
      overlay={UserDropDownMenu({ onSignOut, organization })}
      trigger="click"
      placement="bottomRight"
      onVisibleChange={(value) => setActive(value)}
    >
      <a className="user__dropdown-link" onClick={(e) => e.preventDefault()} href="fake-href">
        <Avatar
          className={classnames("user__avatar-icon", {
            "user__avatar-icon--active": active,
          })}
          size={32}
          shape="square"
        >
          <Text className="user__avatar-icon-text" strong>
            {userName[0].toUpperCase()}
          </Text>
        </Avatar>

        <Text className={classnames({ "user__username--active": active })} strong>
          {userName}
        </Text>
      </a>
    </Dropdown>
  );
};

export default User;
